module.exports = __webpack_public_path__ + "static/media/corte.14937520.jpg";